<template>
  <section
    class="component-b4c019ae"
    resmed-component-name="feature_video_3grid_cta"
    v-bind:style="{ background: acf.layout['background'] }"
  >
    <transition name="fade">
      <div class="component" v-if="inview">
        <div class="container px-xs-sm-2">
          <div class="row">
            <div class="col">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="
                  acf.layout['alignment'] === 'center' ? 'center' : ''
                "
              ></eyebrow-icon>
              <h2 v-bind:class="[`-options-align-${acf.layout.alignment}`]">
                {{ acf.headline }}
              </h2>
            </div>
          </div>
          <div class="row">
            <!-- md lg xl -->
            <div
              class="col-lg-9"
              v-if="$root.mode !== 'xs' && $root.mode !== 'sm'"
            >
              <div class="stage">
                <div class="entry embed-responsive embed-responsive-16by9">
                  <video
                    id="stage"
                    class="video-js vjs-16-9 embed-responsive-item"
                    controls
                    preload="auto"
                  ></video>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="items mt-3 mt-lg-0">
                <!-- xs sm -->
                <div
                  class="stage"
                  v-bind:class="[`order-${order}`]"
                  v-if="$root.mode === 'xs' || $root.mode === 'sm'"
                >
                  <div class="entry embed-responsive embed-responsive-16by9">
                    <video
                      id="stage"
                      class="video-js vjs-16-9 embed-responsive-item"
                      controls
                      preload="auto"
                    ></video>
                  </div>
                </div>

                <div
                  class="item embed-responsive embed-responsive-16by9"
                  v-for="(item, index) in items"
                  v-bind:key="item.id || index"
                  v-bind:class="{
                    [`order-${index + 1}`]: true,
                    'is-active': active === item.id,
                  }"
                  v-on:click="swap(item, index)"
                >
                  <figure class="embed-responsive-item">
                    <figcaption>
                      <p class="now-playing">Now playing</p>
                    </figcaption>
                    <div
                      class="embed-responsive-item poster"
                      v-bind:style="{
                        'background-image': `url(${item.poster_url || item.poster})`,
                      }"
                    ></div>
                  </figure>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4" v-if="cta.href">
            <div class="col-md-12 text-center">
              <a
                v-bind:href="cta.href"
                v-bind:target="cta.target[0]"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import inview from "../../mixins/inview";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "@videojs/http-streaming";

export default {
  name: "component-b4c019ae", // feature_video_3grid_cta
  props: ["acf"],
  data() {
    return {
      player: null,
      order: 0,
      account: "",
      active: "",
      player_id: "",
      items: [],
      cta: [],
    };
  },
  mixins: [inview],
  watch: {
    inview(val) {
      val && this.initializePlayer();
    },
  },
  methods: {
    getVideoUrl(item) {
      return item.hls_url || item.aprimo_url || "";
    },
    swap(item, index) {
      this.order = index + 1;
      this.active = item.id;
      this.player_id = item.player;
      const src = this.getVideoUrl(item);

      if (this.player && src) {
        this.player.src({
          src,
          type: "application/x-mpegURL",
        });

        // Configure subtitles if present
        if (item.subtitles) {
          this.player.textTracks().removeTrack(this.player.textTracks()[0]);
          const subtitleTracks = item.subtitles.split(",");
          subtitleTracks.forEach((track) => {
            const [lang, url] = track.split(":");
            this.player.addRemoteTextTrack(
              {
                kind: "captions",
                src: url.trim(),
                srclang: lang.trim(),
                label: lang.trim(),
              },
              true
            );
          });
        }

        // Update poster if present
        if (item.poster_url) {
          this.player.poster(item.poster_url);
        }

        this.player.play();
      }
    },
    initializePlayer() {
      if (this.player) return; // Already initialized

      const activeItem = this.items.find((item) => item.id === this.active);
      const src = activeItem ? this.getVideoUrl(activeItem) : "";
      if (!src) return;

      this.player = videojs("stage", {
        controls: true,
        autoplay: false,
        preload: "auto",
        fluid: true,
      });

      // Set initial video source
      this.player.src({
        src,
        type: "application/x-mpegURL",
      });

      // Configure subtitles if present
      if (activeItem.subtitles) {
        const subtitleTracks = activeItem.subtitles.split(",");
        subtitleTracks.forEach((track) => {
          const [lang, url] = track.split(":");
          this.player.addRemoteTextTrack(
            {
              kind: "captions",
              src: url.trim(),
              srclang: lang.trim(),
              label: lang.trim(),
            },
            true
          );
        });
      }

      // Set poster image
      if (activeItem.poster_url) {
        this.player.poster(activeItem.poster_url);
      }
    },
    debounce: debounce(function () {
      // Debounce not needed with Video.js as it handles responsive layout natively
    }, 200),
  },
  mounted() {
    // Initialize player when in view
    if (this.inview) {
      this.initializePlayer();
    }

    // switch stage node
    bus.$on("mode", (arr) => {
      this.debounce(arr);
    });
  },
  beforeDestroy() {
    // Clean up Video.js player to prevent memory leaks
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  },
  created() {
    this.account = this.acf.account;
    this.items = (this.acf.items || []).map((item) => ({
      ...item,
      hls_url: item.hls_url || item.aprimo_url || "",
      poster_url: item.poster_url || item.thumbnail || item.aprimo_thumbnail || item.poster || null,
    }));
    this.cta = this.acf.cta;

    if (this.items.length > 0) {
      this.active = this.items[0].id;
      this.player_id = this.items[0].player;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b4c019ae {
  padding: 5rem 0 6rem 0;
  background: linear-gradient(#1788c3, #004275);
}

h2 {
  position: relative;
  margin-bottom: 1.5rem;
  color: $cc-resmed-white;

  @extend %eyebrow-left;
  &:before {
    background-color: $cc-resmed-white;
  }

  &.-options-align-center {
    text-align: center;

    &:before {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

h3 {
  margin-bottom: 0.5rem;

  @media (min-width: 576px) {
    font-size: 1.125em;
  }

  @media (min-width: 1200px) {
    font-size: 1.5em;
  }
}

.stage {
  margin: 0 0 1rem 0;
  box-shadow: 0 1.25rem 3.75rem 0 rgba(0, 0, 0, 0.3);

  @media (min-width: 768px) {
    margin: 0;
  }
}

.items {
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    margin: 0 -0.5rem;
  }

  @media (min-width: 992px) {
    display: block;
    margin: 0;
  }

  .item {
    margin: 0 0 1rem 0;

    @media (min-width: 768px) {
      width: 33.33%;
      margin: 0 0.5rem;
    }

    @media (min-width: 992px) {
      width: 100%;
      margin: 0 0 0.65rem 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .item {
    background-color: $cc-resmed-black;
    box-shadow: 0 1.25rem 3.75rem 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;

    figure {
      &:before {
        content: "";
        position: absolute;
        width: 100%;
        padding-top: 56.25%;
        z-index: 2;
        background-image: url("#{$assets}/images/icon-play-button.svg");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 4rem 4rem;
        opacity: 0.825;
        transition: opacity 0.5s ease;
      }

      &:hover {
        &:before {
          opacity: 1;
        }
      }

      > div {
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }

      figcaption {
        padding: 1.25rem 1.5rem;
        color: $cc-resmed-white;

        position: absolute;
        z-index: 1;
      }
    }

    .now-playing {
      display: none;
    }

    &.is-active {
      cursor: default;

      @media (max-width: 767px) {
        display: none;
      }

      .poster {
        opacity: 0.25;
      }

      figure {
        &:before {
          opacity: 0 !important;
        }

        .now-playing {
          @extend %body-small-bold;
          background: $cc-resmed-grey-70;
          opacity: 0.825;

          display: inline-block;
          padding: 0.675rem 2rem;
          border-radius: 1.5rem;

          white-space: nowrap;
        }
      }

      figcaption {
        padding: 0;

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>